module.exports = __webpack_public_path__ + "images/skewness-07-desktop.png";